import { AuctionNews, fetchNewsItemsBySearchTerm } from '@/redux/api/auctionNews';
import { createSelector } from 'reselect';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';

/* Action Types */
export const LOAD_AUCTION_NEWS_FAIL = 'la/domain/items/LOAD_AUCTION_NEWS_FAIL';
export const LOAD_AUCTION_NEWS_SUCCESS = 'la/domain/items/LOAD_AUCTION_NEWS_SUCCESS';

export interface State {
    newsItems: AuctionNews[];
}

/* reducer */
const DEFAULT_STATE: State = {
    newsItems: [],
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_AUCTION_NEWS_FAIL:
            return {
                ...state,
                newsItems: [],
            };
        case LOAD_AUCTION_NEWS_SUCCESS:
            return {
                ...state,
                newsItems: action.payload,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.auctionNews;

export const getNewsItems = createSelector(stateSelector, (state) => state.newsItems || []);

/* ACTION CREATORS */
export const fetchAuctionNews = (search) => async (dispatch: Function, getState: Function) => {
    const state = getState();
    const deployment = getDeployment(state);
    try {
        const response = await fetchNewsItemsBySearchTerm({ deployment, search });
        dispatch({
            payload: response.payload,
            type: LOAD_AUCTION_NEWS_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            meta: { search },
            payload: error,
            type: LOAD_AUCTION_NEWS_FAIL,
        });
    }
};
